import {
    availableBarsRestaurantsJobTypes,
    availableCastingJobTypes,
    availableEventSupportJobTypes,
    availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

export default function () {
    return {
        events: [],
        allAvailableJobTypes: [
            ...availableCastingJobTypes,
            ...availableMasterOfCeremoniesJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes
        ],
        showCloneErrorMessage: false,
    }
}
